module.exports = __webpack_public_path__ + "img/user-3.d4090c13.png";